import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { Plus } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { selectWork } from '../../Api/selectors';
import { InvoiceSelection } from "./InvoiceSelection";
import { selectInvoices } from "../selectors";
import { REQUEST_INVOICE_SET_PARENT_INVOICE, REQUEST_INVOICE_SET_SUB_INVOICE } from "../constants";
import { addParentInvoice, addSubInvoice } from "../actions";

const STATE = {
  edit: false,
  selectedInvoice: null,
};

const Container = styled.div`
  width: 100%;
  max-width: 225px;
  .title {
    white-space: nowrap;
  }
`;

const Title = styled.div`
  border: 1px solid black;
  border-radius: 12px;
  font-size: 14px;
  padding: 4px 8px;
  margin: 8px 0;
  text-align: center;
  max-width: 185px;
`

/* eslint-disable react/prefer-stateless-function */
class InvoiceStructureSelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  get empty() {
    if (this.props.relation == 'parent') return !this.invoice.parentInvoices?.length;
    return !this.invoice.parentInvoices?.length;
  }

  get work() {
    if (this.props.relation == 'parent') return this.props.workParent;

    return this.props.workSub;
  }

  applySelection() {
    this.props.addInvoiceRelation(this.state.selectedInvoice.id, this.reset.bind(this));
  }

  render() {
    if (this.work) return <Loader small />;
    return (
      <Container
        className={`structure-selection ${this.props.relation} ${this.empty ? 'empty' : ''}`}
      >
        <Title>
          {this.lbl(`company.details.structure.${this.props.relation}`)}
        </Title>
        {this.renderEdit()}
      </Container>
    );
  }

  renderEdit() {
    if (!this.state.edit) return false;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl(`company.details.structure.${this.props.relation}`)}>
        {this.state.selectedInvoice ? (
          <>{this.state.selectedInvoice.id}</>
        ) : (
          <InvoiceSelection invoice={this.props.invoice} onSelect={selectedInvoice => this.setState({ selectedInvoice })} />
        )}
        <ModalControls>
          <Button onClick={this.applySelection.bind(this)} primary disabled={!this.state.selectedInvoice}>
            {this.lbl('ok')}
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

InvoiceStructureSelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    companies: selectInvoices(),
    workSub: selectWork([REQUEST_INVOICE_SET_SUB_INVOICE]),
    workParent: selectWork(REQUEST_INVOICE_SET_PARENT_INVOICE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    addInvoiceRelation(relationId, callback) {
      let invoiceId = ownProps.invoice.id;
      if (ownProps.relation === 'parent') {
        dispatch(addParentInvoice(invoiceId, relationId, callback));
      } else {
        dispatch(addSubInvoice(invoiceId, relationId, callback));
      }
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InvoiceStructureSelection = compose(
  withConnect,
  withRouter,
)(InvoiceStructureSelectionComp);
